/* eslint-disable no-unreachable */
import setting from '@/setting'
import api from '@/api'

export default class {
    years = [];
    months = [];
    leagues = [];
    levels = [];
    stadiums = [];
    teams = [];
    pitchers = [];
    selectedYear = 2015;
    selectedMonth = '';
    selectedLeague = '';
    selectedLevel = '';
    selectedStadium = '';
    selectedTeam = '';
    selectedArm = '';
    selectedPitcher = '';
    selectedBall1 = '';
    gameCount = '';
    ballMains = []; // 全投球情報
    ball1Filter = [];   // フィルターされた投球1
    ball2Filter = [];
    // PT1向けデータ変換用に必要なデータ
    typesOf3DSearchPitchCall = {
        'StrikeSwinging': {
            name: '空振ストライク'
        },
        'StrikeSwingingZone': {
            name: '空振ストライク（ゾーン内）'
        },
        'StrikeSwingingO-Zone': {
            name: '空振ストライク（ゾーン外）'
        },
        'StrikeCalled': {
            name: '見逃しストライク'
        },
        'FoulBall': {
            name: 'ファール'
        },
        'BallCalled': {
            name: 'ボール'
        },
        'BallCalledHitByPitch': {
            name: 'デッドボール'
        }
    };
    typesOf3DSearchKorBB = {
        'Strikeout': {
            name: '三振'
        },
        'StrikeoutSwinging': {
            name: '三振（空振り）'
        },
        'StrikeoutCalled': {
            name: '三振（見逃し）'
        },
        'Walk': {
            name: '四球'
        }
    };
    api = api;
    checkBoxs = []; // チェックボックスの値
    $root = {};
    avgSpeed = {
        Fastball: 0,
        Slider: 0,
        Curveball: 0,
        Splitter: 0,
        ChangeUp: 0,
        Sinker: 0,
        Cutter: 0,
    };
    selectedBall1Id = '';
    constructor(saveData, $root, getBall = true, getAvgSpeed = true,) {
        this.years = saveData.years
        this.months = saveData.months
        this.leagues = saveData.leagues
        this.levels = saveData.levels
        this.stadiums = saveData.stadiums
        this.teams = saveData.teams
        this.pitchers = saveData.pitchers
        this.subBalls = saveData.subBalls
        this.typeOfBalls = saveData.typeOfBalls
        this.selectedYear = saveData.selectedYear
        this.selectedMonth = saveData.selectedMonth
        this.selectedLeague = saveData.selectedLeague
        this.selectedLevel = saveData.selectedLevel
        this.selectedStadium = saveData.selectedStadium
        this.selectedTeam = saveData.selectedTeam
        this.selectedArm = saveData.selectedArm
        this.selectedPitcher = saveData.selectedPitcher
        this.selectedBall1 = saveData.selectedBall1
        this.ballMains = saveData.ballMains
        this.ball1Filter = saveData.ball1Filter
        this.ball2Filter = saveData.ball2Filter
        this.checkBoxs = saveData.checkBoxs
        this.gameCount = saveData.gameCount
        this.selectedBall1Id = saveData.selectedBall1Id || this.selectedBall1Id
        this.$root = $root
        if (getBall) this.getBalls()
        if (getAvgSpeed) this.getBallAvgSpeed()
    }

    /**
     * function
     * @description 投手ID、チーム、日付、リーグ、レベルを基に投球データを取得する
     */
    getBalls() {
        if (this.$root.$store.getters.ptDatas.ballMains.length > 0 && this.$root.$store.getters.ptDatas.ball1Filter.length > 0 && this.$root.$store.getters.ptDatas.ball2Filter.length > 0) {
            this.ballMains = this.$root.$store.getters.ptDatas.ballMains  // 全投球データ保存
            this.ball1Filter = this.$root.$store.getters.ptDatas.ball1Filter
            // this.ball2Filter = this.$root.$store.getters.ptDatas.ball2Filter
            this.getSubBall(false)
        } else {
            const period = this.getPeriodObj()
            const league = this.selectedLeague
            const level = this.selectedLevel
            const pitcher = `${this.selectedPitcher}@${this.selectedTeam}`
            const query = {
                'date-after': period.afterDate,
                'date-before': period.beforeDate,
                league: league,
                level: level,
                pitcher: pitcher,
                limit: '500',
                he_first: true
            }

            api.PITCHES.getIndex(query, (json) => {
                const data = json.filter((d) => {
                    return d.pitchingdata != null // nullのレコードを除外
                })
                this.ballMains = this.formatComparePitchingData(data).map(d => this.formatForPT1(d))  // 全投球データ保存
                this.ball1Filter = this.filterMainBall(this.ballMains, this.selectedBall1)
                this.getSubBall(false)
            },
            (error) => {
                this.$alert('投球データを取得出来ませんでした')
                console.error(error)
            }
                , false)
        }
    }

    getBallAvgSpeed() {
        const period = this.getPeriodObj()
        const option = {
            'date-after': period.afterDate,
            'date-before': period.beforeDate
        }
        if (this.$root.$store.getters.ptDatas.ballAvgSpeed !== null) {
            let avgSpeed = this.$root.$store.getters.ptDatas.ballAvgSpeed
            this.avgSpeed.Fastball = avgSpeed.TaggedPitchType.Fastball !== undefined ? avgSpeed.TaggedPitchType.Fastball.avg_relspeed / 1000 : 0
            this.avgSpeed.Slider = avgSpeed.TaggedPitchType.Slider !== undefined ? avgSpeed.TaggedPitchType.Slider.avg_relspeed / 1000 : 0
            this.avgSpeed.Curveball = avgSpeed.TaggedPitchType.Curveball !== undefined ? avgSpeed.TaggedPitchType.Curveball.avg_relspeed / 1000 : 0
            this.avgSpeed.Splitter = avgSpeed.TaggedPitchType.Splitter !== undefined ? avgSpeed.TaggedPitchType.Splitter.avg_relspeed / 1000 : 0
            this.avgSpeed.ChangeUp = avgSpeed.TaggedPitchType.ChangeUp !== undefined ? avgSpeed.TaggedPitchType.ChangeUp.avg_relspeed / 1000 : 0
            this.avgSpeed.Sinker = avgSpeed.TaggedPitchType.Sinker !== undefined ? avgSpeed.TaggedPitchType.Sinker.avg_relspeed / 1000 : 0
            this.avgSpeed.Cutter = avgSpeed.TaggedPitchType.Cutter !== undefined ? avgSpeed.TaggedPitchType.Cutter.avg_relspeed / 1000 : 0
        } else {
            api.PITCHES.ANALYSIS.getDetail(this.selectedPitcher, this.selectedTeam, option, (json) => {
                this.$root.$store.commit('setPtDatasBallAvgSpeed', json)
                this.avgSpeed.Fastball = json.TaggedPitchType.Fastball !== undefined ? json.TaggedPitchType.Fastball.avg_relspeed / 1000 : 0
                this.avgSpeed.Slider = json.TaggedPitchType.Slider !== undefined ? json.TaggedPitchType.Slider.avg_relspeed / 1000 : 0
                this.avgSpeed.Curveball = json.TaggedPitchType.Curveball !== undefined ? json.TaggedPitchType.Curveball.avg_relspeed / 1000 : 0
                this.avgSpeed.Splitter = json.TaggedPitchType.Splitter !== undefined ? json.TaggedPitchType.Splitter.avg_relspeed / 1000 : 0
                this.avgSpeed.ChangeUp = json.TaggedPitchType.ChangeUp !== undefined ? json.TaggedPitchType.ChangeUp.avg_relspeed / 1000 : 0
                this.avgSpeed.Sinker = json.TaggedPitchType.Sinker !== undefined ? json.TaggedPitchType.Sinker.avg_relspeed / 1000 : 0
                this.avgSpeed.Cutter = json.TaggedPitchType.Cutter !== undefined ? json.TaggedPitchType.Cutter.avg_relspeed / 1000 : 0
            }, (error) => {
                console.log(error)
                this.$alert('平均速度取得に失敗しました')
            }, false)
        }
    }

    /**
     * function
     * @description 引数として渡された球種のみ抽出する
     * @param json
     * @param target
     * @return {*}
     */
    filterMainBall(json, target) {
        const result = json.filter((data, i) => {
            return data.data.pitchingdata.TaggedPitchType === target
        })
        if (result.length === 0) this.$alert('該当するデータは0件です')
        return result
    }

    getPeriodObj() {
        let afterDate = ''
        let beforeDate = ''
        if (this.selectedMonth === '') {
            afterDate = `${this.selectedYear}-01-01`
            beforeDate = `${this.selectedYear}-12-31`
        } else {
            afterDate = `${this.selectedYear}-${this.selectedMonth}-01`
            const momentDate = window.moment(`${this.selectedYear}-${this.selectedMonth}-01`)
            beforeDate = momentDate.add(1, 'month').date(0).format('YYYY-MM-DD')
        }
        return {
            afterDate: afterDate,
            beforeDate: beforeDate
        }
    }

    /**
     * @description formatComparePitchingDatのデータをPT1で表示出来る形に変換する
     **/
    formatForPT1(addBall) {
        //formatForPT1
        let uniformNumber = '999'
        if (addBall['original']['Batter']['additional'] !== null && addBall['original']['Batter']['additional'].hasOwnProperty['uniform_number']) {
            uniformNumber = addBall['original']['Batter']['additional']['uniform_number']
        }
        return {
            id: addBall['original']['id'],
            gameId: addBall['original']['game_id'],
            inning: addBall['original']['inning'],
            paofinning: addBall['original']['paofinning'],
            pitchofpa: addBall['original']['pitchofpa'],
            pitcher: {
                id: addBall['original']['Pitcher']['identifier'],
                uniform_number: addBall['original']['Pitcher']['additional']['uniform_number'],
                name: addBall['original']['Pitcher']['name']
            },
            team: {
                id: addBall['original']['Pitcher']['team_id'],
                name: this.$root.$store.getters.listOfTeams[addBall['original']['Pitcher']['team_id']].name_short2
            },
            batter: {
                id: addBall['original']['Batter']['identifier'],
                uniform_number: uniformNumber,
                name: addBall['original']['Batter']['name']
            },
            vsTeam: {
                id: addBall['original']['Batter']['team_id'],
                name: this.$root.$store.getters.listOfTeams[addBall['original']['Batter']['team_id']].name_short2
            },
            data: addBall['original'],
            ballColor: '#ffffff',
            enabled: true,
            ballType: 'compare'
        }
    }

    /**
     * @description
     * APIで取ってきた投球データを加工する
     * **/
    formatComparePitchingData(balls) {
        let compareBalls = []
        balls.forEach((d) => {
            let tmpData = {}
            tmpData.id = ''
            tmpData.original = d
            tmpData.data = {}
            tmpData.data['Date'] = d.pitchingdata['Date']
            tmpData.data['pitchno'] = Number(d['pitchno'])
            tmpData.data['HitType'] = {
                id: d.pitchingdata['HitType'],
                name: d.pitchingdata['HitType'] in setting.typesOfHitType ? setting.typesOfHitType[d.pitchingdata['HitType']].name : '―'
            }
            if (this.formSelectType === 0) {
                tmpData.data['BatterTeamId'] = d['Batter']['team_id']
                tmpData.data['BatterTeamName'] = this.$root.$store.getters[d['Batter']['team_id']].name_short2
                tmpData.data['BatterId'] = d['Batter']['identifier']
                tmpData.data['BatterName'] = d['Batter']['name']
            } else {
                tmpData.data['BatterTeamId'] = ''
                tmpData.data['BatterTeamName'] = '-'
                tmpData.data['BatterId'] = ''
                tmpData.data['BatterName'] = '-'
            }
            tmpData.data['result'] = {
                id: '',
                name: '―'
            }
            // 判定結果振り分け インプレイ
            if (d.pitchingdata['PitchCall'] === 'InPlay') {
                tmpData.data['result'] = {
                    id: d.pitchingdata['PlayResult'],
                    name: setting.typesOfPlayResult[d.pitchingdata['PlayResult']].name
                }
                // 判定結果振り分け インプレイ以外の三振、四球
            } else if (d.pitchingdata['KorBB'] !== 'Undefined') {
                let KorBBID = ''
                let KorBBName = '-'
                if (d.pitchingdata['KorBB'] === 'Strikeout') {
                    if (d.pitchingdata['PitchCall'] === 'StrikeSwinging') {
                        KorBBID = 'StrikeoutSwinging'
                        KorBBName = '三振（空振り）'
                    } else if (d.pitchingdata['PitchCall'] === 'StrikeCalled') {
                        KorBBID = 'StrikeoutCalled'
                        KorBBName = '三振（見逃し）'
                    }
                } else {
                    KorBBID = d.pitchingdata['KorBB']
                    KorBBName = this.typesOf3DSearchKorBB[d.pitchingdata['KorBB']].name
                }
                tmpData.data['result'] = {
                    id: KorBBID,
                    name: KorBBName
                }
                // 判定結果振り分け インプレイ以外の空振りストライク、見逃しストライク、ファール、ボール、デッドボール
            } else if (d.pitchingdata['PitchCall'] !== 'Undefined') {
                let pitchCallID = ''
                let pitchCallName = '-'
                if (d.pitchingdata['PitchCall'] === 'StrikeSwinging') {
                    if (d.pitchingdata['Zone'] === 'Zone') {
                        pitchCallID = 'StrikeSwingingZone'
                        pitchCallName = '空振ストライク（ゾーン内）'
                    } else {
                        pitchCallID = 'StrikeSwingingO-Zone'
                        pitchCallName = '空振ストライク（ゾーン外）'
                    }
                } else if (d.pitchingdata['PitchCall'] === 'HitByPitch') {
                    pitchCallID = 'BallCalledHitByPitch'
                    pitchCallName = 'デッドボール'
                } else {
                    pitchCallID = d.pitchingdata['PitchCall']
                    // 登録されていないもの（BallIntentional）などはそのまま表示する
                    if (this.typesOf3DSearchPitchCall[d.pitchingdata['PitchCall']] === undefined) {
                        pitchCallName = d.pitchingdata['PitchCall']
                    } else {
                        pitchCallName = this.typesOf3DSearchPitchCall[d.pitchingdata['PitchCall']].name
                    }
                }
                tmpData.data['result'] = {
                    id: pitchCallID,
                    name: pitchCallName
                }
            }
            tmpData.data['checkPitchCall'] = d.pitchingdata['PitchCall']
            tmpData.data['checkZone'] = d.pitchingdata['Zone']
            tmpData.data['TaggedPitchType'] = setting.typesOfBall[d.pitchingdata.TaggedPitchType].name
            tmpData.data['AlphaTaggedPitchType'] = d.pitchingdata.TaggedPitchType
            tmpData.data['RelSpeed'] = Math.round(d.pitchingdata['RelSpeed'] / 1000)
            // tmpData.data['RelSpeed_Per'] = Math.round(((d.pitchingdata['RelSpeed'] / 1000) * 100) / balls.mostFastBall.ave_speed)
            if (d.pitchingdata['SpinRate'] !== null) {
                tmpData.data['SpinRate'] = (Math.round(d.pitchingdata['SpinRate']))
            } else {
                tmpData.data['SpinRate'] = '―'
            }
            if (d.pitchingdata['Rifle'] !== null) {
                tmpData.data['Rifle'] = Math.round(d.pitchingdata['Rifle'])
            } else {
                tmpData.data['Rifle'] = '―'
            }
            if (d.pitchingdata['w_sin_a'] !== null) {
                tmpData.data['w_sin_a'] = Math.round(d.pitchingdata['w_sin_a'])
            } else {
                tmpData.data['w_sin_a'] = '―'
            }
            tmpData.data['InducedVertBreak'] = Math.round(d.pitchingdata['InducedVertBreak'] * 100)
            tmpData.data['HorzBreak'] = Math.round(d.pitchingdata['HorzBreak'] * 100)
            tmpData.data['DeflectionAngle'] = Math.round(d.pitchingdata['DeflectionAngle'])
            tmpData.data['Depth'] = Math.round(d.pitchingdata['Depth'] * 100)
            tmpData.data['RelHeight'] = Math.round(d.pitchingdata['RelHeight'] * 100)
            tmpData.data['RelSide'] = Math.round(d.pitchingdata['RelSide'] * 100)
            tmpData.data['Extension'] = Math.round(d.pitchingdata['Extension'] * 100)
            if (d.pitchingdata['PA'] !== undefined) {
                tmpData.data['AtBat'] = d.pitchingdata['PA']
            } else {
                tmpData.data['AtBat'] = '-'
            }
            tmpData.id = d['id']
            tmpData.data['PitchUID'] = d['id']
            compareBalls.push(tmpData)
        })
        return compareBalls
    }

    getSubBall(alert = true) {
        // this.subBalls[index].value = !this.subBalls[index].value
        if (this.ballMains.length === 0) return
        this.ball2Filter = this.filterSubBall(this.ballMains, this.checkBoxs, alert)
        this.$root.$store.commit('setPtDatasBall2Filter', this.filterSubBall(this.ballMains, this.checkBoxs, alert))
    }

    /**
     * @description 引数として渡された球種の配列に一致する球情報を抽出する
     * @param json
     * @param targets
     * @param alert
     */
    filterSubBall(json, targets, alert) {
        const result = json.filter((data) => {
            return targets.includes(data.data.pitchingdata.TaggedPitchType)
        })
        if (result.length === 0 && alert) this.$alert('該当するデータは0件です')
        return result
    }

}
